import { useMemo } from "react";

import Box from "@mui/material/Box";
import { Theme, useMediaQuery } from "@mui/material";

import { Covertree } from "@covertree/ui/brand";
import { DrawerNavigation } from "@covertree/ui/navigation";

import { ContactInfo } from "./ContactInfo";

interface DesktopSidebarProps {
  contactPhoneNumber: string;
  sections: Record<string, string[]>;
}

export function DesktopSidebar({
  contactPhoneNumber,
  sections,
}: DesktopSidebarProps) {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  const drawerNavigationItems = useMemo(
    () =>
      Object.entries(sections).map(([name, paths]) => ({
        name,
        paths,
      })),
    [sections]
  );

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      flexDirection="column"
      height="100%"
      py={2}
      sx={{
        gridColumnStart: 2,
        gridColumnEnd: "span 3",
        paddingX: {
          xs: 3,
          md: 0,
        },
      }}>
      <Box>
        {isDesktop && (
          <Box height={136} pt={1}>
            <Covertree height={100} width={86} />
          </Box>
        )}
        <DrawerNavigation items={drawerNavigationItems} />
      </Box>

      <ContactInfo contactPhoneNumber={contactPhoneNumber} />
    </Box>
  );
}
